import useTheme from "@mui/material/styles/useTheme";
import { SvgIcon, SvgIconProps } from "designSystem/index";
import { grey, white } from "designSystem/styles/color";
import React, { FunctionComponent } from "react";

interface LockHorzRotationIconProps extends SvgIconProps {
	selected?: boolean;
}

const LockHorzRotationIcon: FunctionComponent<LockHorzRotationIconProps> = ({ ...props }) => {
	const { selected } = props;
	const { palette } = useTheme();	
	const primary = palette.primary.main;
	const secondary = palette.NavListItemSelectedBG;
	
	return (
		<SvgIcon {...props} viewBox="0 0 26 26">
			<path
				d="M11.5037 13C8.27289 13 6.99585 11.8 6.99585 11C6.99585 10.2 8.24161 9 12.9998 9C17.7579 9 19.0042 10 19.0042 11C19.0042 11.8 17.8498 13 14.619 13"
				fill={selected ? secondary: white[50]}
				stroke={selected ? primary : grey["A100"]}
			/>
			<path
				clipRule="evenodd"
				d="M14.5037 6V20H11.5037V6H14.5037Z"
				fill={selected ? primary : grey["A100"]}
				fillRule="evenodd"
			/>
			<path
				d="M11.9998 12.809L12.3817 13L11.9998 13.191L11.9998 12.809Z"
				fill="white"
				stroke="white"
			/>		
		</SvgIcon>
	);
};

export default LockHorzRotationIcon;